module.exports = __webpack_public_path__ + "img/logo.66448ce2.jpg";